import  { useEffect, useState } from 'react';
import brands from '../../../demo/brands.json'; 
import './BrandsDropdown.scss';
import { useNavigate } from 'react-router-dom'
import { Brands } from '../../../types/Brands';
import { executeFetch } from '../../../helper/Api';
import useCategoryStore from '../../../store/categoryStore';
const BrandsDropdown = () => {
  //States
  const [isOpen, setIsOpen] = useState(false);
  const {brands} = useCategoryStore();
  const navigate = useNavigate();
//Actions
  const handleBrandClick = (brand) => {
    setIsOpen(false); 
     navigate(`/products?b=${brand.id}`)
  };
//Effects


  return (
    <div className="brands-dropdown">
        <div className="b-text" onClick={() => setIsOpen(!isOpen)}>
        Μάρκες
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="dropdown-item"
              onClick={() => handleBrandClick(brand)}
            >
              {brand.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandsDropdown;